import axios from "axios";

export const securePaymentApi = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

securePaymentApi.interceptors.request.use(config => {
  const token = process.env.VUE_APP_SECURE_PAYMENT_TOKEN;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});
